import { FC, ReactElement } from 'react';
import { IUploadButton, UploadButtonTypes } from './UploadButton.types';
import { PrimaryUploadButton, SecondaryUploadButton } from './ui';

type PropsType = Omit<IUploadButton, 'variant'>;
type MapperType = {
  [key in UploadButtonTypes]: ReactElement;
};

const UploadButtonVariant: FC<PropsType> = props => {
  const { type, text, fileTypes, onUpload } = props;

  const options = {
    text,
    exts: fileTypes.join(','),
    onUpload,
  };

  const buttonMapper: MapperType = {
    primary: <PrimaryUploadButton {...options} />,
    secondary: <SecondaryUploadButton {...options} />,
  };

  return buttonMapper[type];
};

export default UploadButtonVariant;
